// Dependencies
import React, { Component } from 'react';

class SectionContainer extends Component {
    render() {
        let paddingTop = this.props['paddingTop'] ? this.props['paddingTop'] : 40;
        let paddingBottom = this.props['paddingBottom'] ? this.props['paddingBottom'] : 40;
        return (
            <section className={this.props.grey ? `g-bg-secondary` : ``}
                style={ 
                    {
                        backgroundColor: this.props['backgroundColor'] ? this.props['backgroundColor'] : '',
                        color: this.props['color'] ? this.props['color'] : '',
                        paddingTop: paddingTop === 0 ? '' : `${paddingTop}px`,
                        paddingBottom: paddingBottom  === 0 ? '' : `${paddingBottom}px`
                    }
                }>
                <div className="container">
                    {this.props.children}
                </div>
            </section>
        );
    }
}

export default SectionContainer;


// WEBPACK FOOTER //
// ./src/subcomponents/SectionContainer.js